import { render } from "./Sms.vue?vue&type=template&id=2d01348e&scoped=true"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2d01348e"

export default script